/**
 * Prefix matching is case-sensitive; the subsequence fallback ignores case and whitespace.
 * @returns Original text split into typed characters and untyped completion runs.
 */
export function getCompletionTextSegments({ text, query, allowSubsequence, }) {
    if (query.length === 0) {
        return [[text, '']];
    }
    if (text.startsWith(query)) {
        const completion = text.slice(query.length);
        return completion
            ? [
                [query, ''],
                ['', completion],
            ]
            : [[text, '']];
    }
    // Preserve prefix-only rendering for providers that do not opt into character matching.
    // Original query length includes spaces, even though fallback matching ignores them.
    if (!allowSubsequence || query.length > text.length || !isNonSequentialMatch({ query, text })) {
        return [[text, '']];
    }
    return splitIntoInputsAndCompletions({ input: query, full: text });
}
function isNonSequentialMatch({ query, text }) {
    const compressedQuery = query.replace(/\s+/g, '').toLocaleLowerCase();
    let queryIndex = 0;
    let textIndex = 0;
    while (queryIndex < compressedQuery.length && textIndex < text.length) {
        if (compressedQuery[queryIndex] === text[textIndex]?.toLocaleLowerCase()) {
            queryIndex++;
        }
        textIndex++;
    }
    return queryIndex === compressedQuery.length;
}
function splitIntoInputsAndCompletions({ input, full, }) {
    const compressedInput = input.replace(/\s+/g, '');
    const result = [];
    let currentMatch = '';
    let currentNonMatch = '';
    let inputIndex = 0;
    let fullIndex = 0;
    while (inputIndex < compressedInput.length && fullIndex < full.length) {
        if (compressedInput[inputIndex]?.toLocaleLowerCase() === full[fullIndex]?.toLocaleLowerCase()) {
            if (currentNonMatch) {
                result.push(['', currentNonMatch]);
                currentNonMatch = '';
            }
            currentMatch += full[fullIndex];
            inputIndex++;
            fullIndex++;
        }
        else {
            if (currentMatch) {
                result.push([currentMatch, '']);
                currentMatch = '';
            }
            currentNonMatch += full[fullIndex];
            fullIndex++;
        }
    }
    if (currentMatch) {
        result.push([currentMatch, '']);
    }
    if (currentNonMatch) {
        result.push(['', currentNonMatch]);
    }
    if (fullIndex < full.length) {
        result.push(['', full.slice(fullIndex)]);
    }
    return result;
}
//# sourceMappingURL=completionText.js.map